module.exports = __webpack_public_path__ + "static/put-second-webhook-13ca1957303433ac8e38d7cd1ad63798.png";